import { IonButton, IonText, useIonModal } from '@ionic/react'
import moment from 'moment-timezone'
import { useContext, useState } from 'react'
import styled from 'styled-components'
import { CustomSpacer, PagingContent } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react'
import { TradeCancelModal } from './modals/TradeCancelModal'

type Props = {
  productId: number
}

export const TradeHistoryYet: React.FC<Props> = observer(({ productId }) => {
  const { marketStore } = useContext(StoresContext)
  const [propsValues, setPropsValues] = useState({
    productId: 0,
    count: 0,
    remainCount: 0,
    cost: 0,
    type: '',
    id: 0,
  })
  const pagingStore = marketStore.tradeHistoryYetPagingStore

  const [txDetailPresent, txDetailDismiss] = useIonModal(TradeCancelModal, {
    propsValues: propsValues,
    onDismiss: () => {
      txDetailDismiss()
    },
  })

  const onTxDetailModal = (
    productId: number,
    count: number,
    remainCount: number,
    cost: number,
    type: 'SELL' | 'BUY',
    id: number,
  ) => {
    setPropsValues({
      productId: productId,
      count: count,
      remainCount: remainCount,
      cost: cost,
      type: type,
      id: id,
    })
    txDetailPresent()
  }

  //총 거래 금액
  const totalCost = (count: number, cost: number) => {
    const totalCost = Math.abs(count) * cost
    return Math.floor(totalCost).toLocaleString('ko-Kr')
  }

  return (
    <PagingContent pagingStore={pagingStore} loadParam={{ param: { productId: productId } }}>
      {pagingStore.list.map((d, i) => (
        <ProductInfoContainer key={i}>
          <DateContainer>
            <IonText className="date">{`${moment(new Date(d.createdDate)).format('YY.MM.DD')}`}</IonText>
            <IonText className="time">{`${moment(new Date(d.createdDate)).format('HH:MM')}`}</IonText>
          </DateContainer>
          <SectionContainer>
            <ContentContainer onClick={() => onTxDetailModal(d.id, d.count, d.remainCount, d.cost, d.type, d.id)}>
              <TitleWrap>
                <span>
                  <IonText color={d.type === 'SELL' ? 'danger' : 'primary'} className="section-title">
                    {d.type === 'SELL' ? '매도' : '매수'}
                  </IonText>
                  <IonText className="order-sequence">(주문 번호 : {d.orderSequence})</IonText>
                </span>
                <IonButton fill={'clear'} color={'dark'}>
                  거래취소
                </IonButton>
              </TitleWrap>
              <CustomSpacer spacing="16px" />
              <ContentWrap>
                <div>
                  <IonText className="title">단가 </IonText>
                  <IonText>{d.cost.toLocaleString('ko-Kr') ?? 0} 원</IonText>
                </div>
                <IonText>주문 {Math.abs(d.count ?? 0).toLocaleString()} 개</IonText>
              </ContentWrap>
              <ContentWrap>
                <div>
                  <IonText className="title">주문가 </IonText>
                  <IonText>{totalCost(d.count, d.cost).toLocaleString() ?? 0} 원</IonText>
                </div>
                <IonText>잔여 {d.remainCount.toLocaleString() ?? 0} 개</IonText>
              </ContentWrap>
            </ContentContainer>
            <CustomSpacer spacing="16px" bottomLine={true} />
            <CustomSpacer spacing="16px" />
          </SectionContainer>
        </ProductInfoContainer>
      ))}
    </PagingContent>
  )
})

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
`

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  .section-title {
    font-size: 16px;
    font-weight: 700;
  }
  .order-sequence {
    margin-left: 4px;
    font-size: 11px;
    font-weight: 400;
    color: #888888;
  }
`

const ContentWrap = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 400;
  .bold {
    font-weight: bold;
  }
  div {
    display: flex;
    justify-content: space-between;
    .title {
      width: 43px;
    }
  }
`
const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 400;
  .bold {
    font-weight: bold;
  }
  div {
    display: flex;
    justify-content: space-between;
    .title {
      width: 27px;
    }
  }
  ion-button {
    float: right;
    width: 42px;
    height: 15px;
    font-size: 12px;
    margin: 3px 0 0 0;
    border-bottom: solid 1px #000000;
  }
`

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  .date {
    font-size: 12px;
    font-weight: 700;
  }
  .time {
    font-size: 11px;
    font-weight: 400;
    color: #888888;
  }
`

const ContentContainer = styled.div`
  cursor: 'pointer';
`
